@if (isSchemaReady()) {
<form [formGroup]="form" (ngSubmit)="$event.preventDefault()">
  <div class="dynamic-plugin-section">
    <formly-form
      [form]="pluginValuesGroup"
      [fields]="dynamicFields()"
      [model]="model.plugin_values"
      (modelChange)="onPluginModelChange($event)"
    >
    </formly-form>
  </div>

  @if (saveError(); as error) {
  <p class="mt-3 text-sm text-red-600">{{ error }}</p>
  }
</form>
}
